import { getElementsByClassName } from '../../../../utils/utils';
export class TextSizeGroupItems {
    parent;
    cachedGroupItems = [];
    constructor(parent) {
        this.parent = parent;
    }
    get performer() {
        return this.parent;
    }
    get childs() {
        return getElementsByClassName(`textGrowChild_${this.performer.group.groupName}`);
    }
    get cachedChilds() {
        return this.cachedGroupItems;
    }
    get currentScaledFontSize() {
        if (this.cachedChilds.length > 0) {
            return parseInt(this.cachedChilds[0].style.fontSize || '14');
        }
        return 14;
    }
    get minFontSize() {
        return Math.min(...this.cachedChilds.map(child => numberFromAttribute(child.dataset.textgrowmin) || 10)) || 10;
    }
    get maxFontSize() {
        return Math.max(...this.cachedChilds.map(child => numberFromAttribute(child.dataset.textgrowmax) || 35)) || 35;
    }
    decreaseFontSize() {
        const decreasedFontSize = this.currentScaledFontSize - 1;
        // console.log('decreaseFontSize', decreasedFontSize + 'px');
        this.cachedChilds.forEach(child => this.setFontSizeForChild(decreasedFontSize, child));
    }
    increaseFontSize() {
        const increasedFontSize = this.currentScaledFontSize + 1;
        // console.log('increaseFontSize', increasedFontSize + 'px');
        this.cachedChilds.forEach(child => this.setFontSizeForChild(increasedFontSize, child));
    }
    setFontSizeForChild(fontSize, child) {
        const individualChildMinFontSize = numberFromAttribute(child.dataset.textgrowmin) || this.minFontSize;
        const individualChildMaxFontSize = numberFromAttribute(child.dataset.textgrowmax) || this.maxFontSize;
        const scopedFontSize = Math.max(Math.min(fontSize, individualChildMaxFontSize), individualChildMinFontSize);
        if (child.getAttribute('data-fontsizemanual') === '1') {
            return;
        }
        child.style.fontSize = `${scopedFontSize}px`;
    }
}
function numberFromAttribute(dataAttribute) {
    if (!dataAttribute)
        return undefined;
    return parseInt(dataAttribute);
}
